import Swiper from "swiper/bundle";

const container = document.querySelectorAll(".awards-slider");

if (container) {
  container.forEach((el) => {
    const award = el.querySelector(".award-swiper");
    const nextEl = el.querySelector(".button-next");
    const prevEl = el.querySelector(".button-prev");
    const swiper = new Swiper(award, {
      // Optional parameters
      loop: true,
      autoplay: {
        delay: 5000,
      },
      slidesPerView: 2,
      spaceBetween: 30,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 35,
        },
        992: {
          slidesPerView: 6,
          spaceBetween: 40,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });
  });
}
